import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedinIcon, MailIcon, PhoneIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-dark text-white py-12" data-id="element-39">
      <div className="container mx-auto px-6" data-id="element-40">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center" data-id="element-41">
          <div className="mb-8 md:mb-0" data-id="element-42">
            <h3 className="text-xl font-display font-semibold mb-2" data-id="element-43">
              Emma Rose
            </h3>
            <p className="text-sm text-gray-300" data-id="element-44">
              Product Leader in Health & Wellness
            </p>
          </div>
          <div className="flex items-center space-x-6" data-id="element-45">
            <a href="mailto:emma0rose@gmail.com" className="text-white hover:text-coral-light transition-colors" aria-label="Email" data-id="element-46">
              <MailIcon size={20} data-id="element-47" />
            </a>
            <a href="tel:+447570039548" className="text-white hover:text-coral-light transition-colors" aria-label="Phone" data-id="element-48">
              <PhoneIcon size={20} data-id="element-49" />
            </a>
            <a href="https://linkedin.com/in/emma-rose" target="_blank" rel="noopener noreferrer" className="text-white hover:text-coral-light transition-colors" aria-label="LinkedIn" data-id="element-50">
              <LinkedinIcon size={20} data-id="element-51" />
            </a>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-52">
          <p className="text-sm text-gray-400 mb-4 md:mb-0" data-id="element-53">
            &copy; {new Date().getFullYear()} Emma Rose. All rights reserved.
          </p>
          <div className="flex space-x-6" data-id="element-54">
            <Link to="/" className="text-sm text-gray-400 hover:text-white transition-colors" data-id="element-55">
              Home
            </Link>
            <Link to="/about" className="text-sm text-gray-400 hover:text-white transition-colors" data-id="element-56">
              About
            </Link>
            <Link to="/contact" className="text-sm text-gray-400 hover:text-white transition-colors" data-id="element-57">
              Contact
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}